import { Form, Dropdown, DropdownButton, InputGroup } from "react-bootstrap";
import SimpleBar from "simplebar-react";

export const DrawingNoteWithPresets = ({ text, setText }) => {
    return (
        <Form.Group controlId='input-small' className='mb-3'>
            <Form.Label className='text-body fs-sm me-2 pe-1 text-nowrap'>
                Text
            </Form.Label>
            <InputGroup className="mb-3" size="sm">
                <Form.Control size='sm' value={ text } onChange={ (e) => setText(e.target.value) } />
                <DropdownButton variant="outline-secondary" align="end" size="sm">
                    <SimpleBar autoHide={ false } className='simplebar-no-autohide pe-3' style={ { maxHeight: '200px' } }>

                        {/* Start PVS/GTel items (we need to make these configurable)  */ }
                        <Dropdown.Item href="#" onClick={ () => setText("BL") }>Building Line: BL</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("CL") }>Curb Line: CL</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("DW") }>Driveway: DW</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("FL") }>Fence Line: FL</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("RE") }>Road Edge: RE</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("SW") }>Sidewalk: SW</Dropdown.Item>
                        {/* End PVS/GTel items --------------------------------------  */ }

                        <Dropdown.Item href="#" onClick={ () => setText("B") }>Cable: B</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("C") }>Conduit: C</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("F/O") }>Fibre: F/O</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("BSW") }>Service Wire: BSW</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("GM") }>Gas Main: GM</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("GS") }>Gas Service: GS</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("HP") }>Hydro One Primary: HP</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("H") }>Hydro Trench: H</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("HS") }>Secondary: HS</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("SL") }>Streetlight Cable: SL</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("SA") }>Sani Mainline: SA</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("SA") }>Force Main: SA</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("ST") }>Storm Mainline: ST</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("TC") }>Traffic Cable: TC</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("HS") }>Electrical Feed: HS</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("IC") }>Interconnect: IC</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("LOOP") }>Signal Loop: LOOP</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("WM") }>Water Main: WM</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={ () => setText("WS") }>Water Service: WS</Dropdown.Item>
                    </SimpleBar>
                </DropdownButton>
            </InputGroup>
        </Form.Group>
    )
}